<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0 pl-3 pr-3" cols="12" id="head_title">
			<v-row class="ma-0 pa-0" align="center" id="header_height">
				<router-link :to="{ path: $routerHistory.previous().path }"
					style="color:transparent;">
					<v-col class="ma-0 pa-0" cols="auto" align="center"
						style="color:#08B0FF;font-size:1rem;text-align:center;">
						{{t('storeSearch')}}
					</v-col>
				</router-link>
				<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
					src="@/assets/images/history_arrow.png"></v-img>
				<v-col class="ma-0 pa-0" cols="auto">
					{{tsc('searchList')}}
				</v-col>
			</v-row>
		</v-col>
    <v-col id="main_content_minwidthset" class="ma-0 pa-0" cols="12">
			<v-row id="left_info_box" class="ma-0 pa-0" align="start">
				<v-col class="ma-0 pa-3 pr-1" cols="2" align="left">
					
					<v-row class="mb-2 mt-2 ml-2 pa-0 fontSet"  align="center" width="auto" height="2rem"  style="font-size:0.8rem;color:#008DD0;">
						{{tsc('brand')}}
						<v-img max-height="1rem" max-width="0.6rem" class="ma-0 pa-0 ml-2" src="@/assets/images/blue_right_icon.png"/>
					</v-row>

					<v-col class="ma-0 pa-3 pt-0 pb-1 fontSet" cols="auto"> {{tsc('brand')}}: </v-col>
					<v-row class="ma-0 pa-0" align="center">
            <!-- <v-col class="ma-0 pa-3 pt-0 pb-1" cols="auto">
              {{searchCondition.selectedBrands.brandName}}
            </v-col> -->
						<v-col class="ma-0 pa-3 pr-0 pt-0 pb-1" cols="auto"
							v-for="brand, index in searchCondition.selectedBrands" :key="index">
							{{brand.brandName}}	
						</v-col>
					</v-row>

					<v-col class="ma-0 pa-3 pt-0 pb-1 mt-7" cols="12">
						<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
					</v-col>
					
					<v-row class="mb-2 mt-2 ml-2 pa-0 fontSet" align="center" width="auto" height="2rem" style="font-size:0.8rem;color:#008DD0;">
						{{tsc('region')}}
						<v-img max-height="1rem" max-width="0.6rem" class="ma-0 pa-0 ml-2" src="@/assets/images/blue_right_icon.png"/>	
					</v-row>
					
					<v-row class="ma-0 pa-3 pt-0 pb-1" align="center">
						<v-col class="ma-0 pa-0 pr-2" cols="auto"
							v-for="area, index in searchCondition.selectedAreas" :key="index">
							{{area}}	
						</v-col>
					</v-row>
					<v-col class="ma-0 pa-3 pt-0 pb-1 mt-4" cols="12">
						<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
					</v-col>
					
					<v-row class="mb-2 mt-2 ml-2 pa-0 fontSet" align="center" width="auto" height="2rem" style="font-size:0.8rem;color:#008DD0;">
						{{t('filtering')}}
						<v-img max-height="1rem" max-width="0.6rem" class="ma-0 pa-0 ml-2" src="@/assets/images/blue_right_icon.png"/>
					</v-row>
					
					<v-col class="ma-0 pa-3 pt-0 pb-1" cols="auto">
						<v-col class="ma-0 pa-0" cols="auto" 
							v-if="searchCondition.setFilterConditions.motionBeginDate != ''">
							{{t('motionDetect') + ' ' + searchCondition.setFilterConditions.motionBeginDate.substr(0,19).replace('T',' ')}}
						</v-col>
						<v-col class="ma-0 pa-0" cols="auto" 
							v-if="searchCondition.setFilterConditions.motionEndingDate != ''">
							{{'~ ' + searchCondition.setFilterConditions.motionEndingDate.substr(0,19).replace('T',' ')}}
						</v-col>
						<v-col class="ma-0 pa-0" cols="auto" 
							v-if="searchCondition.setFilterConditions.soundBeginDate != ''">
							{{t('soundDetect') + ' ' + searchCondition.setFilterConditions.soundBeginDate.substr(0,19).replace('T',' ')}}
						</v-col>
						<v-col class="ma-0 pa-0" cols="auto" 
							v-if="searchCondition.setFilterConditions.soundEndingDate != ''">
							{{'~ ' + searchCondition.setFilterConditions.soundEndingDate.substr(0,19).replace('T',' ')}}
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-3 pt-0 pb-1 mt-4" cols="12">
						<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
					</v-col>

					<v-row class="mb-2 mt-2 ml-2 pa-0 fontSet" align="center" width="auto" height="2rem" style="font-size:0.8rem;color:#008DD0;">
						{{t('tag')}}
						<v-img max-height="1rem" max-width="0.6rem" class="ma-0 pa-0 ml-2" src="@/assets/images/blue_right_icon.png"/>
					</v-row>

					<v-col class="ma-0 pa-3 pt-0 pb-1" cols="12">
						<v-row class="ma-0 pa-0" align="start" justify="start">
							<v-col class="ma-0 pa-0" cols="auto"
								v-for="item in tagList" :key="item.label">
								<template>
									<v-card width="auto" height="auto" class="ma-0 pa-2 pt-0 pb-0 pl-3 pr-3 mr-1 mb-2" 
										id="blue_btn" elevation="0" style="border-radius:25px;font-size:0.8rem;">
										{{item.label}}	
									</v-card>
								</template>
							</v-col>
						</v-row>
					</v-col>
				</v-col>


				<v-col class="ma-0 pa-0 mb-10" cols="10">
        	<v-col class="pa-0" id="main_content_maxwidthset" cols="12">
						<template v-if="fetchLoading == false">
							<v-col class="ma-0 pa-0 pl-5 pr-5 pb-5 mb-5" cols="12"
								style="border-bottom:1px solid #4C4C4C;"
								v-for="(item, index) in storeList" :key="index">
								<v-row class="ma-0 pa-0 mt-2 mb-2" align="center" justify="space-between">
									<v-row class="ma-0 pa-0" align="center">
										<!-- <template v-if="authorities.ADD_STORE_GROUP">
											<input id="check_box" v-model="item.checked" type="checkbox" />
										</template> -->
										<v-col class="ma-0 pa-0 ml-5" cols="auto" align="left"
											style="font-weight:bold;">
											{{item.customerName}}
										</v-col>
									</v-row>
									<!-- <v-menu offset-y v-if="authorities.ADD_STORE_GROUP">
										<template v-slot:activator="{ on, attrs }">
											<v-btn id="back_clean_btn" class="ma-0 pa-0"
												width="auto" height="2rem" v-bind="attrs" v-on="on">
												<v-img height="2rem" width="2rem" class="ma-0 pa-0"
													src="@/assets/images/more_black.png"></v-img>
											</v-btn>
										</template>
										<v-list class="ma-0 pa-0" dense>
											<v-list-item>
												<v-list-item-title align="left"
													style="color:#707070;">{{ tsc('addToStoreGroup') }}</v-list-item-title>
											</v-list-item>
											<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
											<v-list-item v-for="(store, index) in storeGroupList" :key="index">
												<v-list-item-title align="left" @click="addToGroup(item, store)">{{ store.groupName }}</v-list-item-title>
											</v-list-item>
											<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
											<v-list-item @click="goStoreGroup(item)">
												<v-list-item-title align="left">{{ tsc('createAndAddGroup') }}</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu> -->
								</v-row>
								<v-row class="ma-0 pa-0 pl-5" align="start">
									<v-col class="ma-0 pa-0 pr-4" cols="3" v-if="item.numberOfUas == 0">
										<v-col id="data_box" class="ma-0 pa-0" cols="12">
											<v-row class="ma-0 pa-0" style="height: 11.45rem;"></v-row>
										</v-col>
									</v-col>
									<v-col class="ma-0 pa-0 pr-4" cols="3" v-else>
										<v-col id="data_box" class="ma-0 pa-0" cols="12"
											style="cursor: pointer;" @click="goStoreAnalyze(item)">
											<v-col class="ma-0 pa-3 pl-5 pr-5" cols="12">
												<v-col class="ma-0 pa-0 mb-1" cols="12">
													<v-row class="ma-0 pa-0" align="center" justify="space-between"
														style="font-weight:bold;">
														<v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
															{{tsc('last30DaysVisitors')}}
														</v-col>
														<v-col class="ma-0 pa-0" cols="auto">
															<v-row class="ma-0 pa-0" align="center"
																style="color: #008DD0;font-size:0.8rem;">
																{{tsc('viewAnalyze')}}
																<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
																	src="@/assets/images/blue_right_icon.png"></v-img>
															</v-row>
														</v-col>
													</v-row>
												</v-col>
												<v-col id="data_people_box" class="ma-0 pa-0" cols="12">
													<v-row class="ma-0 pa-0" align="center">
														<v-col class="ma-0 pa-1" cols="6">
															<v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12" 
																align="left">{{tsc('all')}}</v-col>
															<v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12" 
																align="left">{{totalCountList[index].total + tsc('peopleCount')}}</v-col>
														</v-col>
														<v-col class="ma-0 pa-1" cols="6">
															<v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12" 
																align="left">{{tsc('faceRecognition')}}</v-col>
															<v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12" 
																align="left">{{totalCountList[index].known + tsc('peopleCount')}}</v-col>
														</v-col>
													</v-row>
												</v-col>
											</v-col>
											<v-col class="ma-0 pa-0 pr-2 pb-3" cols="12" style="position: relative;">
												<BarChart :chart-data="visitorDataseList[index]" :options="chartOptionsList[index]"
													:height="75"></BarChart>
												<v-col id="no_data" class="ma-0 pa-0" cols="12"
													v-if="fetchLoading == false && visitorDataseList[index].datasets[0].data.length == 0">
													{{t('noData')}}
												</v-col>
											</v-col>
										</v-col>
									</v-col>
									<v-col class="ma-0 pa-0" cols="9"
										v-if="authorities.GET_RECORDING_SUB_BRANCH">
										<v-col id="data_box" class="ma-0 pa-0" cols="12"
											style="cursor: pointer;" @click="goStoreCCTV(item)">
											<v-col class="ma-0 pa-3 pl-5 pr-5 pb-4" cols="12">
												<v-row class="ma-0 pa-0 mb-1" align="center" justify="space-between"
													style="font-weight:bold;">
													<v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
														{{tsc('camera')}}
													</v-col>
													<v-col class="ma-0 pa-0" cols="auto">
														<v-row class="ma-0 pa-0" align="center"
															style="color: #008DD0;font-size:0.8rem;">
															{{tsc('viewCameras')}}
															<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
																src="@/assets/images/blue_right_icon.png"></v-img>
														</v-row>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-0" v-if="item.storeCameras.length != 0">
													<v-row class="ma-0 pa-0" align="center">
														<v-col v-for="(item_nest, index_nest) in item.storeCameras" :key="index_nest" 
															class="ma-0 pa-0 pr-1 pb-1" cols="3">
															<v-col class="ma-0 pa-0">
																<v-img v-if="item_nest.streamAble"
																	height="8rem" max-width="100%" class="ma-0 pa-0" 
																	style="background:grey;" :src="item_nest.thumbnail" 
																	@error="thumbnailError('no_data_box_' +item_nest.unisCustomerCd + '_' + index_nest)">
																	<!-- 썸네일 에러일 경우 thumbnailError -->
																	<v-col :id="'no_data_box_' + item_nest.unisCustomerCd + '_' + index_nest" class="ma-0 pa-0 no_data_box_style">
																		{{t('thumbnailError')}}
																	</v-col>
																</v-img>
															</v-col>
														</v-col>
													</v-row>
												</v-row>
												<v-row v-else class="ma-0 pa-0" align="center" justify="center" style="height:8rem;">
													{{t('noCamera')}}
												</v-row>
											</v-col>
										</v-col>
									</v-col>
								</v-row>
							</v-col>
						</template>
						<template v-else>
							<v-col class="ma-0 pa-0 pl-10 pr-7 mb-5" cols="12"
								style="border-top:1px solid #4C4C4C;" v-for="n in 3" :key="n">
								<v-col class="ma-0 pa-3" cols="12" style="height:4rem;"></v-col>
								<v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-0" cols="3">
										<v-skeleton-loader :boilerplate="false" elevation="0" dark 
											type="image" width="100%" height="11rem"
										></v-skeleton-loader>
									</v-col>
									<v-col class="ma-0 pa-0 pl-4" cols="9">
										<v-skeleton-loader :boilerplate="false" elevation="0" dark 
											type="image" width="100%" height="11rem"
										></v-skeleton-loader>
									</v-col>
								</v-row>
							</v-col>
						</template>
					</v-col>
				</v-col>
			</v-row>

			<v-col id="bottom_content" class="ma-0 pa-0" cols="12"
				v-if="checkedStoreList.length > 0">
				<v-row class="ma-0 pa-3" align="center" justify="end">
					<v-col class="ma-0 pa-0 mr-4" cols="auto"> 
						<v-btn width="10rem" height="auto" class="ma-0 pa-2" 
							id="blue_btn" elevation="0" style="border:none;"
							@click="selectGroupDialogVisible = true">
							{{tsc('addGroup')}}
						</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <BrandSearchDialog :dialogVisible="brandSearchDialogVisible"
      @visible="brandSearchDialogVisibleFunc" @editBrands="editBrandsFunc" />
    <StoreSearchDialog :dialogVisible="storeSearchDialogVisible"
      @visible="storeSearchDialogVisibleFunc" @editArea="editAreaFunc" />
    <FilterDialog :dialogVisible="filterDialogVisible" :brandBoxVisible="false" :filterData="filteredData"
      @visible="filterDialogVisibleFunc" @filterParams="filterParamsFunc" />
    <TagDialog :dialogVisible="tagDialogVisible"
      @tagVisible="tagDialogVisibleFunc" @tagNames="tagNamesFunc" />
		<SelectGroupDialog :dialogVisible="selectGroupDialogVisible"
			@visible="selectGroupDialogVisibleFunc" :checkStore="checkedStoreList" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import BarChart from "../../components/barChart.js";
import BrandSearchDialog from '@/components/dialogs/BrandSearchDialog.vue';
import StoreSearchDialog from '@/components/dialogs/StoreSearchDialog.vue';
import FilterDialog from '@/components/dialogs/FilteringDialog.vue';
import TagDialog from '@/components/dialogs/TagDialog.vue';
import SelectGroupDialog from './components/SelectGroupDialog.vue';
// import { StoreList, ChartData3 } from '../whitetest/sampleData';
import * as Option from '@/components/chartOptions';
export default {
	components: {
		BarChart, BrandSearchDialog, StoreSearchDialog, FilterDialog, TagDialog,
		SelectGroupDialog
	},
	mixins: [mixin.common],
	data: () => ({
		authorities: {},
    storeSearchDialogVisible: false,
    brandSearchDialogVisible: false,
    filterDialogVisible: false,
    tagDialogVisible: false,
    selectGroupDialogVisible: false,
		searchCondition: {},
		tagList: [],
		selectedTagList: [],
		storeList: [],
		originStoreList: [],
		checkedStoreList: [],
    cameraList: [],
		fetchLoading: false,
		hourList: [],
		visitorDataseList: [],
		chartOptionsList: [],
		totalCountList: [],
    storeGroupList: [],
    filteredData: {}, //필터링 데이터가 있는 상태에서 필터링 다이얼로그를 열 경우 데이터 전달
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
	}),
	filters: {
		statusFormat: function(str) {
			if(str != undefined) {
				return str.length > 20 ? str.substring(0,20) + '...' : str;
			} else {
				return '';
			}
		},
  },
	watch: {
		storeList: {
			deep: true,
			handler(val, oldVal) {
				this.checkedStoreList = [];
				val.forEach((item) => {
					if(item.checked) this.checkedStoreList.push(item);
				});
				console.log('%cChecked Store List\n', "color:#008DD0;", this.checkedStoreList);
			}
		}
	},
  created() {
    this.authorities = this.$store.getters.getAuthorities;
		this.storeList = this.$store.getters.getStoreSearchResult;
		this.storeList.forEach((store, index) => {
      let storeCamerasList = [];
			store.storeCameras.forEach((item) => {
        if(item.isOnline == false) {
          let data = item;
          data.streamAble = false;
        } else {
          let data = item;
          data.streamAble = true;
					storeCamerasList.push(data);
        }
			});
      this.storeList[index].storeCameras = storeCamerasList;
		});
		this.originStoreList = this.$store.getters.getStoreSearchResult;
    this.storeGroupList = this.$store.state.userData.storeGroupList;
		const condition = JSON.parse(JSON.stringify(this.$store.getters.getSearchCondition));
		this.searchCondition = condition;
		this.tagDataSet();
		console.log('%cStoreList\n', "color:#008DD0;", this.storeList);
		console.log('%cSearch Conditions\n', "color:#008DD0;", condition);
		this.initMakeData();
  },
	mounted() {
		this.fetch24hStoreAnalytics();
		this.fetch30dAnalytics();
	},
	methods: {
		tagDataSet() {
			if(this.searchCondition.tagNames == '') return;
			let tagList = this.searchCondition.tagNames.split(',');
			tagList.forEach((tag) => {
				this.tagList.push({
					label: tag, selected: true
				})
			});
		},
		initMakeData() {
			if(this.storeList.length == 0) return;
			this.visitorDataseList = [];
			this.chartOptionsList = [];
			this.totalCountList = [];
			for(let i = 0; i < this.storeList.length; i++) {
				this.visitorDataseList.push({
					labels: ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00",
					  "15:00", "16:00", "17:00", "20:00", "21:00", "22:00", "23:00", "24:00" ],
					datasets: [
						{
							backgroundColor: "#CFCF39",
							data: [],
							borderWidth: 0,
							borderColor: 'transparent',
							barThickness: 'flex',
							hoverOffset: 0
						},
						{
							backgroundColor: "#9A9A9A",
							data: [],
							borderWidth: 0,
							borderColor: 'transparent',
							barThickness: 'flex',
							hoverOffset: 0
						},
					]
				})
				this.chartOptionsList.push(Option.searchChartOption);
				this.totalCountList.push({ total: 0, known: 0 });
			}
		},
		async fetch24hStoreAnalytics() {
			this.fetchLoading = true;
			let currStart = new Date();
			const from = this.getDateFormatFromHour(currStart)
			this.hourList = await this.make18HourList(currStart);
			// this.hourList = this.make18HourList(new Date('2021-05-25T07:00:00')); // 테스트용
			let curr = new Date();
			const to = this.getDateFormatToHour(curr);
			// console.log(from);
			// console.log(to);
			this.storeList.forEach((item, index, array) => {
				this.networkController.getAnalyticsVisitors({}, 'hour', from, to, item.unisCustomerCd)
				// this.networkController.getAnalyticsVisitors({}, 'hour', '202105250700', '202105252400', '490001322')
				.then(async (res) => {
					console.log(`%cunisCustomerCd = ${item.unisCustomerCd} 24h VisitorData\n`, "color:#008DD0;", res.data);
					if(res.data.length != 0) {
						this.hourList.forEach((hour) => {
							let hourIndex = res.data.findIndex((el, idx, arr) => el.start == hour);
							if(hourIndex != -1) {
								let analytics = res.data[hourIndex];
								this.visitorDataseList[index].datasets[0].data.push(analytics.Data.known);
								this.visitorDataseList[index].datasets[1].data.push(analytics.Data.unknown);
							} else {
								this.visitorDataseList[index].datasets[0].data.push(0);
								this.visitorDataseList[index].datasets[1].data.push(0);
							}
						})
						setTimeout(() => {
							let visitor1DataMax = Math.max(...this.visitorDataseList[index].datasets[0].data);
							let visitor2DataMax = Math.max(...this.visitorDataseList[index].datasets[1].data);
							let getVisitorMax = this.getMaxValue(visitor1DataMax + visitor2DataMax);
							let visitorMax = getVisitorMax;
							this.chartOptionsList[index].scales.yAxes[0].ticks.max = visitorMax;
							this.chartOptionsList[index].scales.yAxes[0].ticks.stepSize = visitorMax/2;
						}, 200);
					}
					if(index == array.length - 1) {
						setTimeout(() => {
							this.fetchLoading = false;
						}, 1250);
					}
				});
			});
		},
		fetch30dAnalytics() {
			let currStart = new Date();
			// let currStart = new Date('20210625T00:00:00'); // 테스트용
			let setStart = new Date(currStart.setDate(currStart.getDate() - 30));
			const from = this.getDateFormatFromHour(setStart);
			let curr = new Date();
			// let curr = new Date('20210625T00:00:00'); // 테스트용
			const to = this.getDateFormatToHour(curr);
			this.storeList.forEach((item, index, array) => {
				this.networkController.getAnalyticsVisitors({}, 'day', from, to, item.unisCustomerCd)
				// this.networkController.getAnalyticsVisitors({}, 'day', '20210525', '20210624', '490001322')
				.then(async (res) => {
					console.log(`%cunisCustomerCd = ${item.unisCustomerCd} 30d VisitorData\n`, "color:#008DD0;", res.data);
					if(res.data.length != 0) {
						let total = 0;
						let known = 0;
						res.data.forEach((analytics, resIndex, array) => {
							total = total + analytics.Data.total;
							known = known + analytics.Data.known;
							if(resIndex == array.length - 1) {
								this.totalCountList[index].total = total;
								this.totalCountList[index].known = known;
							}
						});
					}
				});
			});
		},
		async tagClick(tag) {
			let getIndex = await this.tagList.findIndex((element, index, arr) => element.label === tag.label);
			if(this.tagList[getIndex].selected == false) {
				this.selectedTagList.push(tag);
				this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
			} else {
				this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
				if(this.selectedTagList.length != 0) {
					let selectedGetIndex = await this.selectedTagList.findIndex((element, index, arr) => element.label === tag.label);
					this.selectedTagList.splice(selectedGetIndex, 1);
				}
			}
			console.log(this.selectedTagList);
		},
		goStoreAnalyze(store) {
			this.$store.commit('setStoreData', store);
      this.pushRoute('/store-search/store-analyze', {unisCustomerCd: store.unisCustomerCd});
    },
    goStoreCCTV(store) {
			this.$store.commit('setStoreData', store);
      this.pushRoute('/store-search/store-cctv', {unisCustomerCd: store.unisCustomerCd});
    },
    brandSearchDialogVisibleFunc(visible) {
      this.brandSearchDialogVisible = visible;
    },
    storeSearchDialogVisibleFunc(visible) {
      this.storeSearchDialogVisible = visible;
    },
    filterDialogVisibleFunc(visible) {
      this.filterDialogVisible = visible;
    },
    tagDialogVisibleFunc(visible) {
      this.tagDialogVisible = visible;
    },
		selectGroupDialogVisibleFunc(visible) {
      this.selectGroupDialogVisible = visible;
    },
    goStoreGroup(store) {
			this.$store.commit('setSelectedStoreMakeStoreGroup', store);
      this.pushRoute('/store-group/create', {});
    },
    thumbnailError(idName) { //thumbnail을 못 가져올 경우 no data 표시하도록 활성화
      document.getElementById(idName).style.display='block';
    },
		getDateFormatFromHour(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      return year + month + date + '07';
		},
		getDateFormatToHour(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      return year + month + date + '24';
		},
		zeroPadding(n) {
      return ('00' + n).slice(-2);
    },
		make18HourList(date) {
			return new Promise((resolve, reject) => {
				let result = [];
				let monthValue = date.getMonth() + 1;
				monthValue = monthValue >= 10 ? monthValue : `0${monthValue}`;
				let dayValue = date.getDate();
				dayValue = dayValue >= 10 ? dayValue : `0${dayValue}`;
				// let hourValue = date.getHours();
				// hourValue = hourValue >= 10 ? hourValue : `0${hourValue}`;
				let startDate = new Date(`${date.getFullYear()}-${monthValue}-${dayValue}T07:00:00`);
				for(let i = 0; i < 18; i++) {
					if(i == 0) {
						result.push(`${date.getFullYear()}${monthValue}${dayValue}0700`);
					} else {
						let temp = new Date(startDate.setHours(startDate.getHours() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let hour = temp.getHours();
						hour = hour >= 10 ? hour : `0${hour}`;
						let tempStr = `${year}${month}${day}${hour}00`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		makeAreaStr() {
			return new Promise((resolve, reject) => {
				let areaStr = '';
				this.searchCondition.selectedAreas.forEach((area, index) => {
					let store = this.originStoreList.find((el, index, arr) => el.areaName === area);
					if(index == 0) {
						areaStr = store.areaCd;
					} else {
						areaStr = areaStr + ',' + store.areaCd;
					}
				});
				resolve(areaStr);
			});
		},
		makeBrandCd() {
			return new Promise((resolve, reject) => {
				let brandCd = '';
				// brandCd = this.searchCondition.selectedBrands.brandCd;
				this.searchCondition.selectedBrands.forEach((brand, index) => {
					if(index == 0) brandCd = brand.brandCd;
					else brandCd = brandCd + ',' + brand.brandCd;
				});
				resolve(brandCd);
			});
		},
		async requestSearch() {
			this.fetchLoading = true;
			const areaStr = await this.makeAreaStr();
			const brandStr = await this.makeBrandCd();
			let params = {};
			await this.networkController.getStoresSearch(params, areaStr, 
				brandStr, this.searchCondition.setFilterConditions.motionBeginDate, 
				this.searchCondition.setFilterConditions.motionEndingDate, 
				this.searchCondition.setFilterConditions.soundBeginDate,
				this.searchCondition.setFilterConditions.soundEndingDate, 
				this.searchCondition.tagNames, '')
			.then(async (res) => {
				console.log('%cSearch Result Data\n', "color:#008DD0;", res.data);
				if(res.data.length == 0) {
					this.showToastMessage(this.tmb('noStoresFound'));
					this.fetchLoading = false;
					return;
				}
				let makeSearchResult = [];
				res.data.forEach((item) => {
					item.checked = false;
					makeSearchResult.push(item);
				});
				// await this.$store.commit('setStoreSearchResult', makeSearchResult);
				this.storeList = makeSearchResult;
				makeSearchResult.forEach((item) => {
					if(item.storeCameras.length > 4) item.storeCameras.splice(4);
				});
				this.initMakeData();
				await this.$store.commit('setSearchCondition', {
					selectedBrands: this.searchCondition.selectedBrands,
					selectedAreas: this.searchCondition.selectedAreas,
					setFilterConditions: this.searchCondition.setFilterConditions,
					tagNames: this.searchCondition.tagNames
				});
				if(res.data.length > 0) {
					setTimeout(() => {
						this.fetch24hStoreAnalytics();
						this.fetch30dAnalytics();
					}, 200);
				}
			}).catch(error => {
				this.fetchLoading = false;
			});
		},
		editBrandsFunc(brands) {
			if(brands.length == 0) {
				this.storeList = [];
				this.searchCondition.selectedBrands = brands;
			} else {
				this.storeList = [];
				this.searchCondition.selectedBrands = brands;
				this.requestSearch();
			}
		},
		editAreaFunc(areas) {
			if(areas.length == 0) {
				this.storeList = [];
				this.searchCondition.selectedAreas = areas;
			} else {
				this.storeList = [];
				this.searchCondition.selectedAreas = areas;
				this.requestSearch();
			}
		},
		filterParamsFunc(params) {
			this.storeList = [];
			this.searchCondition.setFilterConditions = params;
			setTimeout(() => {
				this.requestSearch();
			}, 100);
		},
		tagNamesFunc(tagNames) {
			this.storeList = [];
			let tagList = tagNames.split(',');
			this.searchCondition.tagNames = tagNames;
			this.tagList = tagList.map(item => {
				return { label: item, selected: true }
			});
			setTimeout(() => {
				this.requestSearch();
			}, 100);
		},
    async addToGroup(storeData, item) {
      let storeList = item.stores;
      let duplicated = false;
			this.fetchLoading = true;
      storeList.forEach((i) => {
        if(i.unisCustomerCd == storeData.unisCustomerCd) {
          duplicated = true;
        }
      });
      if(duplicated) { //이미 그룹에 속해 있는 경우
				this.showToastMessage(this.tmb('storeAlreadyAdded'));
				this.fetchLoading = false;
      } else {
        storeList.push({customerName : storeData.customerName, unisCustomerCd: storeData.unisCustomerCd});
			  let params = {
          groupName: item.groupName,
			  	stores: storeList,
			  };
			  await this.networkController.updateStoreGroup(params, item.id)
			  .then(async (res) => {
					this.showToastMessage(this.tmb('requestSuccess'));
				  this.fetchLoading = false;
			  }).catch(error => {
					this.showToastMessage(this.tmb('requestFail'));
				  this.fetchLoading = false;
			  });
      }
    },
    filterDialogOpen() {
      this.filteredData = this.searchCondition.setFilterConditions;
      this.filterDialogVisible = true;
    }
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
  z-index: 6;
}
#header_height {
	height: 50px;
}
#left_info_box {
	font-size: 0.8rem;
}
.fontSet {
	font-weight: bold;
}
#middle_divider {
	background-color: #4C4C4C;
}
#data_box {
	background-color: #34363C;
	border-radius: 4px;
}
#data_people_box {
	background-color: #5C5D62;
	border-radius: 4px;
}
#data_sub_title {
	color: #CECED0;
	font-size: 0.8rem;
}
#data_count {
	font-weight: bold;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
}
.no_data_box_style{
  height: 8rem;
  line-height: 8rem;
  text-align: center;
  background: grey;
  color: white;
  display: none;
}
.no_data_box_style_visible{
  height: 8rem;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: grey;
  color: white;
}
#bottom_content {
	background-color: #272A33;
	position: absolute;
	bottom: 0px;
	left: 0px;
	height: 61px;
	border-top: 1px solid #4C4C4C;
	z-index: 4;
}
#no_data {
	font-size: 0.8rem;
	position: absolute;
	z-index: 2;
	top: 30%;
	left: 50%;
	transform: translate(-50%, -35%);
}
</style>